import getConfig from 'next/config';
import { useEffect, useState } from 'react';
import { useEventSource } from './use-event-source';

const {
  publicRuntimeConfig: { API_ORIGIN },
} = getConfig();

const BANNER_MESSAGE_SSE_URL = `${API_ORIGIN}/dashboard-settings/banner-message/stream`;

interface BannerMessageUpdate {
  bannerMessage: string | null;
}

/**
 * React hook that connects to the SSE endpoint for real-time banner message updates.
 */
export const useBannerMessageSSE = (): { bannerMessage: string | null; initialised: boolean } => {
  const [isInitialised, setIsInitialised] = useState<boolean>(false);
  const [data, setData] = useState<BannerMessageUpdate | null>(null);
  const { addListener } = useEventSource<BannerMessageUpdate>({
    url: BANNER_MESSAGE_SSE_URL,
  });

  useEffect(() => {
    const cleanup = addListener((eventData) => {
      setData(eventData);
      setIsInitialised(true);
    });

    return () => {
      cleanup();
    };
  }, [addListener]);

  return { bannerMessage: data?.bannerMessage ?? null, initialised: isInitialised };
};
